import { useAuth } from 'bcp-data';
import { ROLES } from 'src/config';

function useRole() {
  const { user } = useAuth();

  const hasRole = (requiredRoles) => {
    if (!user) return false;
    if (user?.superadmin === true) return true;

    const companies = user?.companies || [];
    if (companies.length === 0) return false;

    const required = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];

    const userRoleNames = companies.map(c => c.role);
    return required.some(roleName => userRoleNames.includes(roleName));
  };

  return {
    role: user?.superadmin ? 'SUPERADMIN' : (user?.companies?.[0]?.role || null),
    hasRole,
    allRoles: user?.superadmin ? ['SUPERADMIN'] : (user?.companies?.map(c => c.role) || [])
  };
}

export default useRole;